<template>
    <div class="pl-10 mb-3 flex flex-row items-center gap-4">
        <feather-icon icon="DownloadIcon" svgClasses="align-middle w-6 text-primary"/>
        <a class="w-48" :href="url" target="_blank">{{ name }}</a>
        <p class="w-20 text-right mb-0 text-sm">{{ size }} MB</p>
        <p class="mb-0 text-sm">{{ etag }}</p>
    </div>
</template>

<script>

export default {
    name: 'ResourceBundleInfo',
    props: {
        response: {
            required: false
        },
    },
    data() {
        return {
            url: '',
            name: '',
            etag: '',
            size: '',
        }
    },
    async created() {
        this.url = this.response.config.url
        this.name = this.url.split('/').pop().split('.')[0]
        this.etag = this.response.headers.etag.replaceAll('"', "")
        this.size = Math.round((this.response.headers['content-length'] / 1024 / 1024) * 100) / 100
    },
}
</script>
